export const storeQuestionLocation = async (resource, data) => {
    let questionarie;
    await resource
      .post(`api/${localStorage.getItem('perfil')}/questionary_location`, data)
      .then(
        (response) => {
          console.log(response);
          questionarie = response.body.questionary;
        },
        (response) => {
          console.log(response);
        }
      );
    return questionarie;
  }
  
export const deleteQuestionaryLocation = async (resource, id) => {
  let questionarie;
  await resource
    .delete(`api/${localStorage.getItem('perfil')}/questionary_location/${id}`)
    .then(
      (response) => {
        console.log(response);
        questionarie = response.body.questionary;
      },
      (response) => {
        console.log(response);
      }
    );
  return questionarie;
}

export const getFindByQuestionarieId = async (resource, questionary_id,location_id) => {
  let questionary;
  await resource
    .get(`api/${localStorage.getItem('perfil')}/questionary_location/find_by_questionary_id/${questionary_id}/${location_id}`)
    .then(
      (response) => {
        console.log(response);
        questionary = response.body.questionary[0];
      },
      (response) => {
        console.log(response);
      }
    );
  return questionary;
}
